import { Component, Input, output, OutputEmitterRef } from "@angular/core";
import { GuidHelper } from "@calaosoft/osapp-common/guid/helpers/guidHelper";
import { ObserveArray } from "@calaosoft/osapp-common/observable/decorators/observe-array.decorator";
import { ObservableArray } from "@calaosoft/osapp-common/observable/models/observable-array";
import { secure } from "@calaosoft/osapp-common/rxjs/operators/secure";
import { IdHelper } from "@calaosoft/osapp-common/utils/helpers/idHelper";
import { EPrefix } from "@calaosoft/osapp-common/utils/models/EPrefix";
import { combineLatest, map, Observable } from "rxjs";
import { ICustomer } from "../../../../../tour/customers/i-customer";
import { DestroyableComponentBase } from "../../../../../utils/components/destroyable-component-base";
import { IMerchandising } from "../../../../models/IMerchandising";
import { ICustomerSelectorPopoverItem } from "../customer-selector-popover-item/i-customer-selector-popover-item";

@Component({
	selector: "calao-customer-selector-popover",
	templateUrl: "./customer-selector-popover.component.html",
	styleUrls: ["./customer-selector-popover.component.scss"],
	standalone: false
})
export class CustomerSelectorPopoverComponent extends DestroyableComponentBase {
	//#region PROPERTIES

	@Input({ required: true })
	public appointments!: IMerchandising[];
	@ObserveArray<CustomerSelectorPopoverComponent>("appointments")
	public readonly observableAppointments = new ObservableArray<IMerchandising>(undefined);

	/** Seuls les clients présents dans les `appointments` seront utilisés. */
	@Input({ required: true })
	public customers!: ICustomer[];
	@ObserveArray<CustomerSelectorPopoverComponent>("customers")
	public readonly observableCustomers = new ObservableArray<ICustomer>([]);

	/** Identifiant du composant pour fermer sa popover et pas une autre. */
	@Input() public componentId: string = GuidHelper.newGuid();

	public readonly items$: Observable<ICustomerSelectorPopoverItem[]>;

	public readonly onChanged: OutputEmitterRef<ICustomerSelectorPopoverItem> = output();

	//#endregion

	//#region METHODS

	constructor() {
		super();

		this.items$ = this.getItems$().pipe(secure(this));
	}

	private getItems$(): Observable<ICustomerSelectorPopoverItem[]> {
		return combineLatest([this.observableAppointments.changes$, this.observableCustomers.changes$]).pipe(
			map(([paAppointment, paCustomer]: [IMerchandising[], ICustomer[]]): ICustomerSelectorPopoverItem[] => {
				const laItems: ICustomerSelectorPopoverItem[] = paAppointment.map(
					(poAppointment: IMerchandising): ICustomerSelectorPopoverItem => {
						return {
							appointment: poAppointment,
							customer: paCustomer.find(
								(poCustomer: ICustomer) =>
									IdHelper.extractIdWithoutPrefix(poCustomer._id, EPrefix.customer) ===
									IdHelper.extractIdWithoutPrefix(poAppointment.clientId, EPrefix.customer)
							)
						};
					}
				);

				return laItems;
			})
		);
	}

	/** Exécute l'action associée à l'objet passé en paramètre.
	 * @param poItem Item dont on veut exécuter l'action.
	 */
	public onClicked(poItem: ICustomerSelectorPopoverItem): void {
		this.onChanged.emit(poItem);
	}

	//#endregion
}
